import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Routes that intentionally use the light executive palette.
const LIGHT_ROUTES = new Set(["/"]);

// Cream theme everywhere except the public landing page.
export function useRouteDarkMode() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    const root = document.documentElement;
    // Member portal uses the cream theme; landing keeps its own light look.
    root.classList.remove("dark");
    root.classList.toggle("kingdom-cream", !LIGHT_ROUTES.has(pathname));
  }, [pathname]);
}
